import { ScenarioWellBase } from './base/scenario-well-base';

export class ScenarioWell extends ScenarioWellBase { }